import apiClient from './client';

// Monitored Activities API (guardian-side)
export const monitoredActivitiesApi = {
  list: () => apiClient.get('/guardians/monitored_activities'),
  get: (id) => apiClient.get(`/guardians/monitored_activities/${id}`),
  create: (data) => apiClient.post('/guardians/monitored_activities', { monitored_activity: data }),
  update: (id, data) => apiClient.patch(`/guardians/monitored_activities/${id}`, { monitored_activity: data }),
  delete: (id) => apiClient.delete(`/guardians/monitored_activities/${id}`),
};

export const monitoredActivitySessionsApi = {
  list: (status = 'completed') =>
    apiClient.get('/guardians/monitored_activity_sessions', { params: { status } }),
  get: (id) => apiClient.get(`/guardians/monitored_activity_sessions/${id}`),
  approve: (id) => apiClient.post(`/guardians/monitored_activity_sessions/${id}/approve`),
  reject: (id) => apiClient.post(`/guardians/monitored_activity_sessions/${id}/reject`),
};
